<template>
  <div class="page-content">
    <div class="page-banner program_banner">
      <div class="page-banner-content">
      <p><span class="pc-browser">VALSE&nbsp;&nbsp;2026&nbsp;&nbsp;</span>POSTERS</p>
      </div>
    </div>
    <div class="main-container">
      <div class="content-item-grp">
        <div class="content-item"  v-show="false">
          <div class="item-title">
            <span class="item-title-content">POSTERS</span>
          </div>
          <div class="item-content"  v-show="false">
            <p class="content-null-info">敬请期待......</p>
          </div>
        </div>
      </div>
      <div class="content-item-grp" v-show="true">
        <!-- <div class="item-content">
            <p class="content-null-info">敬请期待......</p>

          </div> -->
          <div class="content-item" v-show="false">
            <div class="item-title">
              <span class="item-title-content">
                VALSE 2026Poster 暂停征集通知
              <!-- <br/><span class="item-title-label"><a href="https://www.wjx.cn/vm/mIFp6bI.aspx"  target="__blank">>>点击报名</a></span> -->
              </span>
            </div>
            <div class="item-content">
              <div class="item-text-content">
                视觉与学习青年学者研讨会 (VALSE)是一个面向计算机视觉与机器学习领域国内外华人青年学者的学术研讨会。VALSE 2025将于2025年6月6-8日在广东珠海举行，由中国图象图形学学会主办，中山大学承办，中国图象图形学学会青年工作委员会、AutoDL联合协办，预计参会人数5000人。
因大会场地有限，前期Poster报名情况火爆，经组委会商议决定，提前停止Poster征集。再次感谢大家对VALSE的支持！期待与大家在珠海相见！
              </div>
            </div>
        </div>
        <div class="content-item" v-show="false">
            <div class="item-title">
              <span class="item-title-content">
                VALSE 2026 Poster征集
              <br/><span class="item-title-label"><a href="https://www.wjx.top/vm/ex0jyYt.aspx#"  target="__blank">>>点击报名</a></span>
              </span>
            </div>
            <div class="item-content">
              <div class="item-text-content">
                <p>视觉与学习青年学者研讨会(VALSE)是一个面向计算机视觉与机器学习领域国内外华人青年学者的学术研讨会。VALSE 2026将于2026年5月8-10日在湖北武汉举行，由中国图象图形学学会主办，华中科技大学、武汉大学和中国地质大学（武汉）承办，预计参会人数5000人。为了办好 VALSE 2026盛会，我们诚挚邀请您的参与！VALSE旨在为中国青年学者 (以80后、90后、00后为主)在计算机科学、人工智能、机器学习等领域提供一个深度学术交流的平台。在这个聚焦领域的论坛上，我们秉持着理性批判、勇于创新、实证研究的科学精神；倡导在自由平等的原则下进行纯学术的思想碰撞和交流；我们期待国内外青年学者在VALSE 2026这个学术盛宴上，舞动出更加优雅的学术华尔兹。</p>
                <p>Poster投稿申请截止日期：2026年4月5日</p>
                <p>Poster投稿录用通知日期：2026年4月10日</p>
                <p>Poster会议征集范围为2025年以来发表/录用的top 期刊和会议论文。</p>
                <p>报名地址：<a href="https://www.wjx.top/vm/ex0jyYt.aspx#" target="__blank">https://www.wjx.top/vm/ex0jyYt.aspx#</a></p>
                <p>扫描二维码报名：</p>
                <div class="content-image"><img src="static/images/poster.png" width="120px" style="text-align:center"/></div>
                <p>联系人：</p>
                <div><b>刘  波</b>  重庆邮电大学 (boliu@cqupt.edu.cn)</div>
                <div><b>刘袁缘</b>  中国地质大学（武汉） (liuyy@cug.edu.cn)</div>
                <div><b>王  正</b>   武汉大学 (wangzwhu@whu.edu.cn)</div>
                <div><b>王福田</b>  安徽大学 (wft@ahu.edu.cn)</div>
              </div>
            </div>
        </div>
        <div class="content-item" v-show="true">
          <div class="item-title" v-show="true">
            <span class="item-title-content">
              Poster
              <!-- <br/><span class="item-title-label"><a href="./static/valse2019_poster_template.pptx">>>点击下载POSTER模板</a></span>
              <br/><span class="item-title-label small-label">展板尺寸：170cm*120cm（宽*高）</span> -->
            </span>
            <div class="item-text-content" v-show="false">
              <h3>6月7日中午12:00-13:30：</h3>
              <p><b>A.</b> 生成、恢复与合成 (Generation, Restoration & Synthesis): 侧重于创建新视觉数据（图像、视频、3D）或增强/修复现有数据。</p>
              <p><b>B.</b> 大型模型与多模态交互 (Large Models & Multimodal Interaction): 侧重于大型基础模型（LLM、VLM）的适配、微调、提示工程、多模态融合与推理。</p>
              <p><b>C.</b> 感知、识别与重建 (Perception, Recognition & Reconstruction): 侧重于场景和目标的理解，包括检测、分割、跟踪、姿态估计、3D重建（非生成式）、视觉定位等。</p>
              <p><b>D.</b> 学习策略、基准与应用 (Learning Strategies, Benchmarks & Applications): 侧重于训练方法（联邦/持续/对抗学习）、效率优化、鲁棒性、新数据集/基准测试、特定领域应用（医学、机器人、遥感等）。</p>

              <h3>6月7日下午17:00-18:30：</h3>
              <p><b>E.</b> 生成、恢复与合成 (Generation, Restoration & Synthesis): 侧重于创建新视觉数据（图像、视频、3D）或增强/修复现有数据。</p>
              <p><b>F.</b> 大型模型与多模态交互 (Large Models & Multimodal Interaction): 侧重于大型基础模型（LLM、VLM）的适配、微调、提示工程、多模态融合与推理。</p>
              <p><b>G.</b> 感知、识别与重建 (Perception, Recognition & Reconstruction): 侧重于场景和目标的理解，包括检测、分割、跟踪、姿态估计、3D重建（非生成式）、视觉定位等。</p>
              <p><b>H.</b> 学习策略、基准与应用 (Learning Strategies, Benchmarks & Applications): 侧重于训练方法（联邦/持续/对抗学习）、效率优化、鲁棒性、新数据集/基准测试、特定领域应用（医学、机器人、遥感等）。</p>
            </div>
            <div class="item-text-content" v-show="false">
              <p><b>模板下载地址：</b><a href="./static/poster_template.zip" download class="download-link">点击下载POSTER模板</a></p>
              <p><b>Poster尺寸要求：Poster最大和最合适尺寸：190cmx115cm</b></p>
              <p><b>会场附近打印Poster信息：</b>天亿图文广告快印(横琴店)</p>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;详细地址：广东省-珠海市-香洲区-十字门大道中交汇通横琴广场广州银行旁。</p>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;备注：打印店店距离会场（珠海国际会展中心）直线距离 1.8km，乘车距离5.2公里（约10分钟车程）。</p>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;打印价格：按照尺寸190cmx115cm打印海报的价格大约60元人民币。</p>
              <p><b>其他说明：</b><span style="color:red; font-weight:bold;">在Poster 展示环节，我们会向各位参会者发放拇指贴纸，听众将为人气海报投票。</span></p>

            </div>

          </div>
          <br/>
          <p><b><span style="font-size:20px;font-weight:bold; color:red;" v-show="false">人气海报列表</span></b></p>
          <div class="item-content">
            <!--<p class="content-null-info">敬请期待......</p>-->
            <div class="poster-item"  v-for="(poster, index) in this.highlight">
              <div class="poster-item-number">
                <!-- <span style="color:red; font-weight:bold;">No.{{poster.workshop}}</span>
                <br/>
                <span style="color:red; font-weight:bold;">{{poster.points}}赞</span>
                <br/> -->
                {{poster.number}}
                <br/>
              </div>
              <div class="poster-item-content">
                <div class="poster-item-label"><span class="poster-item-label-span">论文题目：</span><span class="poster-item-title-text">{{poster.title}}</span>
                <!-- <template v-if='poster.workshop!=""'>
                <span style="color:#409EFF;font-weight:bold;">({{poster.workshop}})</span>
                </template> -->
                </div>
                <div class="poster-item-label"><span class="poster-item-label-span">讲者单位：</span>{{poster.unit}}</div>
                <div class="poster-item-label"><span class="poster-item-label-span">期刊或会议：</span>{{poster.qikan}}</div>
                <div class="poster-item-label"><span class="poster-item-label-span">全部作者：</span>{{poster.author}}</div>
                <!-- <a  target='_blank' :href="poster.href" style="font-weight:bolder;">[PosterPDF]</a> -->
              </div>
            </div>
          </div>
          <p><b><span style="font-size:20px;font-weight:bold;">Poster列表</span></b></p>
          <div class="item-content">
            <!--<p class="content-null-info">敬请期待......</p>-->
            <div class="poster-item"  v-for="(poster, index) in this.posters">
              <div class="poster-item-number">{{poster.number}}</div>
              <div class="poster-item-content">
                <div class="poster-item-label"><span class="poster-item-label-span">论文题目：</span><span class="poster-item-title-text">{{poster.title}}</span>
                <!-- <template v-if='poster.workshop!=""'>
                <span style="color:#409EFF;font-weight:bold;">({{poster.workshop}})</span>
                </template> -->
                </div>
                <div class="poster-item-label"><span class="poster-item-label-span">讲者单位：</span>{{poster.unit}}</div>
                <div class="poster-item-label"><span class="poster-item-label-span">期刊或会议：</span>{{poster.qikan}}</div>
                <div class="poster-item-label"><span class="poster-item-label-span">全部作者：</span>{{poster.author}}</div>
                <!-- <a  target='_blank' :href="poster.href" style="font-weight:bolder;">[PosterPDF]</a> -->
              </div>
            </div>
          </div>
        </div>
        </div> 
    </div>
    <div class="footer">
      <p>© VALSE 2026 All rights reserved</p>
      <!--<img src="../../static/images/other-footer-bg.png"/>-->
    </div>

  </div>
</template>

<script>
    export default {
        name: "Posters",
        data () {
          return {
            posters:this.$posters.poster,
            highlight:this.$posters.highlight
          }
        },
        beforeMount(){
          for (var i=1;i<=this.posters.length;i++){
            var number = 1;
            var poster = this.posters[i-1]
            if(i<10){
              number = "00"+i;
            }
            else if(i<100){
              number = "0"+i;
            }
            else{
              number = ""+i;
            }
            var href = "./static/poster/"+number+".pdf"
            this.posters[i-1]['href'] = href
            // console.log(this.posters[i-1]['href'])
          }
        }
    }
</script>

<style scoped>
  .program_banner{
    background-image: url("../../static/images/sub_banner/08.jpg");

  }
  .program_banner p{
    /*color: white;*/
  }
  .footer{
    /* position: fixed; */
    bottom: 0;
  }
  .info-label{
		color: red;
		font-weight: 500;
	}
  .item-title-label a{
    font-size: 14px;

  }
  .content-image{
    width: 120px;
    margin: 0 auto;
  }
  .item-title-label.small-label{
    font-size: 14px;
    color: red;
  }
  .bottom-btn{
    width: 300px;
    font-weight: 500;
  }
  .poster-item{
    display: flex;
    text-align: left;
    align-items: center;
    padding: 12px 14px;
    margin-bottom: 8px;
    border-radius: 8px;
    border: 1px solid #c5d4e8;
    background-color: #e2eaf5;
    transition: background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
  }
  .poster-item:nth-child(even){
    background-color: #d4e0f2;
    border-color: #b4c6e0;
  }
  .poster-item:hover{
    background-color: #b9d0ec;
    border-color: #8fb4d9;
    box-shadow: 0 2px 8px rgba(0, 83, 161, 0.15);
  }
  .poster-item-label-span{
    font-weight: bold;
  }
  .poster-item-title-text{
    font-weight: 600;
  }
  .poster-item-number{
    /*max-width: 50px !important;*/
    padding: 8px;
    text-align: center;
    color: #0053a1;
    font-weight: bolder;
    font-size: 18px;
    /*border: 1px solid #0053a1;*/
    /*border-radius: 24px;*/
  }
  .poster-item-content{
    /*float: left;*/
  }
  .item-text-content p{
    padding:0 0;
    margin: 0;
    font-weight:normal;
  }
  @media screen  and (max-width: 800px){
    .program_banner{
      /*background-image: url("../../static/images/posters-banner.jpg");*/
      /*background-size: cover;*/
      /*background-position: 28% 100%;*/

    }
    .program_banner p{
      /*font-size: 24px;*/
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Posters.vue